module.exports = __webpack_public_path__ + "img/team-2.265a3cc4.jpg";